import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    options: Array,
    create: Boolean,
    items: Array
  }

  connect() {
    this.element.setAttribute("autocomplete", "none")

    const config = {
      selectOnTab: true,
      openOnFocus: true,
      render: {
        option: this.renderOption,
        item: this.renderOption
      }
    }

    if (this.hasOptionsValue) {
      config.options = this.optionsValue
    }

    if (this.createValue) {
      config.create = true
      config.createOnBlur = true
      config.persist = true
    }

    if (this.hasItemsValue) {
      config.items = this.itemsValue
    }

    new TomSelect(this.element, config)
  }

  renderOption(data, escape) {
    return `<div>${escape(data.text)}</div>`
  }
}


